import React from 'react';
import nac from '../assets/NACsecuritysmall.png';

const NAC = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Network Access Control</h1>

        <img src={nac} alt="Network Access Control" style={{
          width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px'
        }} />

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '40px', fontSize: '1.1rem' }}>
          Sarvanta provides two proven security solutions for Network Access Control, giving you
          flexibility to choose the right fit for your infrastructure and compliance requirements.
        </p>

        {/* PacketFence */}
        <div style={{
          padding: '28px', backgroundColor: '#0a1628', borderRadius: '12px',
          border: '1px solid #1a2744', marginBottom: '24px'
        }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#60a5fa' }}>PacketFence</h2>
          <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '16px' }}>
            PacketFence is a fully supported, trusted, free, and open-source network access control
            (NAC) solution. It provides a comprehensive feature set for securing networks of any
            size, from small offices to large heterogeneous enterprise environments.
          </p>
          <h3 style={{ fontSize: '1.1rem', marginBottom: '12px', color: '#e2e8f0' }}>Key Features</h3>
          <ul style={{ color: '#a0aec0', lineHeight: '2', paddingLeft: '20px' }}>
            <li>Captive portal for guest registration and remediation</li>
            <li>Centralized wired and wireless network management</li>
            <li>802.1X authentication support</li>
            <li>Layer-2 isolation of problematic devices</li>
            <li>Integration with Snort IDS for intrusion detection</li>
            <li>Nessus vulnerability scanner integration</li>
            <li>BYOD device onboarding and management</li>
          </ul>
        </div>

        {/* FreeRADIUS */}
        <div style={{
          padding: '28px', backgroundColor: '#0a1628', borderRadius: '12px',
          border: '1px solid #1a2744'
        }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '12px', color: '#60a5fa' }}>FreeRADIUS</h2>
          <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '16px' }}>
            FreeRADIUS is the world's most widely deployed RADIUS server, handling authentication,
            authorization, and accounting for network access. It supports a broad range of
            authentication protocols and integrates with existing directory services.
          </p>
          <h3 style={{ fontSize: '1.1rem', marginBottom: '12px', color: '#e2e8f0' }}>Key Features</h3>
          <ul style={{ color: '#a0aec0', lineHeight: '2', paddingLeft: '20px' }}>
            <li>802.1X authentication for wired and wireless networks</li>
            <li>EAP-TLS, PEAP, and EAP-TTLS support</li>
            <li>LDAP and Active Directory integration</li>
            <li>MAC-based authentication for IoT devices</li>
            <li>Accounting and session tracking</li>
            <li>High availability with failover support</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NAC;
